export const personRolesSelector = state => state.personRoles;
